import { useTranslation } from "react-i18next";
import { ReactComponent as ImgNoInfo } from "../assets/images/img-no-info.svg"


const NoInfo = ({panel,size="lg"}) => {
    const { t } = useTranslation();

    return (
        <div className={`${panel}-no-info img-panel ${size}`}>
            {/* <img src={imgNoInfo} /> */}
            <ImgNoInfo/>
            <span>{t('no_rec')}</span>
        </div>
    )

}
export default NoInfo;